/**
	ensemble des département FR.
	dans le cas d'un dossier en "recherche"
**/
const DepList = [
    { value: '01', label: 'Ain (01)' },
    { value: '02', label: 'Aisne (02)' },
    { value: '03', label: 'Allier (03)' },
    { value: '04', label: 'Alpes-de-Haute-Provence (04)' },
    { value: '05', label: 'Hautes-Alpes (05)' },
    { value: '06', label: 'Alpes-Maritimes (06)' },
    { value: '07', label: 'Ardèche (07)' },
    { value: '08', label: 'Ardennes (08)' },
    { value: '09', label: 'Ariège (09)' },
    { value: '10', label: 'Aube (10)' },
    { value: '11', label: 'Aude (11)' },
    { value: '12', label: 'Aveyron (12)' },
    { value: '13', label: 'Bouches-du-Rhône (13)' },
    { value: '14', label: 'Calvados (14)' },
    { value: '15', label: 'Cantal (15)' },
    { value: '16', label: 'Charente (16)' },
    { value: '17', label: 'Charente-Maritime (17)' },
    { value: '18', label: 'Cher (18)' },
    { value: '19', label: 'Corrèze (19)' },
    { value: '2A', label: 'Corse-du-Sud (2A)' },
    { value: '2B', label: 'Haute-Corse (2B)' },
    { value: '21', label: "Côte-d'Or (21)" },
    { value: '22', label: "Côtes d'Armor (22)" },
    { value: '23', label: 'Creuse (23)' },
    { value: '24', label: 'Dordogne (24)' },
    { value: '25', label: 'Doubs (25)' },
    { value: '26', label: 'Drôme (26)' },
    { value: '27', label: 'Eure (27)' },
    { value: '28', label: 'Eure-et-Loir (28)' },
    { value: '29', label: 'Finistère (29)' },
    { value: '30', label: 'Gard (30)' },
    { value: '31', label: 'Haute-Garonne (31)' },
    { value: '32', label: 'Gers (32)' },
    { value: '33', label: 'Gironde (33)' },
    { value: '34', label: 'Hérault (34)' },
    { value: '35', label: 'Ille-et-Vilaine (35)' },
    { value: '36', label: 'Indre (36)' },
    { value: '37', label: 'Indre-et-Loire (37)' },
    { value: '38', label: 'Isère (38)' },
    { value: '39', label: 'Jura (39)' },
    { value: '40', label: 'Landes (40)' },
    { value: '41', label: 'Loir-et-Cher (41)' },
    { value: '42', label: 'Loire (42)' },
    { value: '43', label: 'Haute-Loire (43)' },
    { value: '44', label: 'Loire-Atlantique (44)' },
    { value: '45', label: 'Loiret (45)' },
    { value: '46', label: 'Lot (46)' },
    { value: '47', label: 'Lot-et-Garonne (47)' },
    { value: '48', label: 'Lozère (48)' },
    { value: '49', label: 'Maine-et-Loire (49)' },
    { value: '50', label: 'Manche (50)' },
    { value: '51', label: 'Marne (51)' },
    { value: '52', label: 'Haute-Marne (52)' },
    { value: '53', label: 'Mayenne (53)' },
    { value: '54', label: 'Meurthe-et-Moselle (54)' },
    { value: '55', label: 'Meuse (55)' },
    { value: '56', label: 'Morbihan (56)' },
    { value: '57', label: 'Moselle (57)' },
    { value: '58', label: 'Nièvre (58)' },
    { value: '59', label: 'Nord (59)' },
    { value: '60', label: 'Oise (60)' },
    { value: '61', label: 'Orne (61)' },
    { value: '62', label: 'Pas-de-Calais (62)' },
    { value: '63', label: 'Puy-de-Dôme (63)' },
    { value: '64', label: 'Pyrénées-Atlantiques (64)' },
    { value: '65', label: 'Hautes-Pyrénées (65)' },
    { value: '66', label: 'Pyrénées-Orientales (66)' },
    { value: '67', label: 'Bas-Rhin (67)' },
    { value: '68', label: 'Haut-Rhin (68)' },
    { value: '69', label: 'Rhône (69)' },
    { value: '70', label: 'Haute-Saône (70)' },
    { value: '71', label: 'Saône-et-Loire (71)' },
    { value: '72', label: 'Sarthe (72)' },
    { value: '73', label: 'Savoie (73)' },
    { value: '74', label: 'Haute-Savoie (74)' },
    { value: '75', label: 'Paris (75)' },
    { value: '76', label: 'Seine-Maritime (76)' },
    { value: '77', label: 'Seine-et-Marne (77)' },
    { value: '78', label: 'Yvelines (78)' },
    { value: '79', label: 'Deux-Sèvres (79)' },
    { value: '80', label: 'Somme (80)' },
    { value: '81', label: 'Tarn (81)' },
    { value: '82', label: 'Tarn-et-Garonne (82)' },
    { value: '83', label: 'Var (83)' },
    { value: '84', label: 'Vaucluse (84)' },
    { value: '85', label: 'Vendée (85)' },
    { value: '86', label: 'Vienne (86)' },
    { value: '87', label: 'Haute-Vienne (87)' },
    { value: '88', label: 'Vosges (88)' },
    { value: '89', label: 'Yonne (89)' },
    { value: '90', label: 'Territoire de Belfort (90)' },
    { value: '91', label: 'Essonne (91)' },
    { value: '92', label: 'Hauts-de-Seine (92)' },
    { value: '93', label: 'Seine-St-Denis (93)' },
    { value: '94', label: 'Val-de-Marne (94)' },
    { value: '95', label: "Val-D'Oise (95)" },
    { value: '971', label: 'Guadeloupe (971)' },
    { value: '972', label: 'Martinique (972)' },
    { value: '973', label: 'Guyane (973)' },
    { value: '974', label: 'La Réunion (974)' },
    { value: '976', label: 'Mayotte (976)' },
]

const CountryList = [
    { value: 'FRA', label: 'France' },
    { value: 'ABW', label: 'Aruba' },
    { value: 'AFG', label: 'Afghanistan' },
    { value: 'AGO', label: 'Angola' },
    { value: 'ALB', label: 'Albanie' },
    { value: 'AND', label: 'Andorre' },
    { value: 'ARE', label: 'Émirats arabes unis' },
    { value: 'ARG', label: 'Argentine' },
    { value: 'ARM', label: 'Arménie' },
    { value: 'AUS', label: 'Australie' },
    { value: 'AUT', label: 'Autriche' },
    { value: 'AZE', label: 'Azerbaïdjan' },
    { value: 'BDI', label: 'Burundi' },
    { value: 'BEL', label: 'Belgique' },
    { value: 'BEN', label: 'Bénin' },
    { value: 'BFA', label: 'Burkina Faso' },
    { value: 'BGD', label: 'Bangladesh' },
    { value: 'BGR', label: 'Bulgarie' },
    { value: 'BHR', label: 'Bahreïn' },
    { value: 'BHS', label: 'Bahamas' },
    { value: 'BIH', label: 'Bosnie-Herzégovine' },
    { value: 'BLR', label: 'Biélorussie' },
    { value: 'BLZ', label: 'Belize' },
    { value: 'BMU', label: 'Bermudes' },
    { value: 'BOL', label: 'Bolivie' },
    { value: 'BRA', label: 'Brésil' },
    { value: 'BRB', label: 'Barbade' },
    { value: 'BRN', label: 'Brunéi' },
    { value: 'BTN', label: 'Bhoutan' },
    { value: 'BWA', label: 'Botswana' },
    { value: 'CAF', label: 'République centrafricaine' },
    { value: 'CAN', label: 'Canada' },
    { value: 'CHE', label: 'Suisse' },
    { value: 'CHL', label: 'Chili' },
    { value: 'CHN', label: 'Chine' },
    { value: 'CIV', label: 'Côte d’Ivoire' },
    { value: 'CMR', label: 'Cameroun' },
    { value: 'COD', label: 'Rép. démocratique du Congo' },
    { value: 'COG', label: 'République du Congo' },
    { value: 'COL', label: 'Colombie' },
    { value: 'COM', label: 'Comores' },
    { value: 'CPV', label: 'Cap-Vert' },
    { value: 'CRI', label: 'Costa Rica' },
    { value: 'CUB', label: 'Cuba' },
    { value: 'CYP', label: 'Chypre' },
    { value: 'CZE', label: 'République tchèque' },
    { value: 'DEU', label: 'Allemagne' },
    { value: 'DJI', label: 'Djibouti' },
    { value: 'DMA', label: 'Dominique' },
    { value: 'DNK', label: 'Danemark' },
    { value: 'DOM', label: 'République dominicaine' },
    { value: 'DZA', label: 'Algérie' },
    { value: 'ECU', label: 'Équateur' },
    { value: 'EGY', label: 'Égypte' },
    { value: 'ERI', label: 'Érythrée' },
    { value: 'ESP', label: 'Espagne' },
    { value: 'EST', label: 'Estonie' },
    { value: 'ETH', label: 'Éthiopie' },
    { value: 'FIN', label: 'Finlande' },
    { value: 'FJI', label: 'Fidji' },
    { value: 'FRA', label: 'France' },
    { value: 'GAB', label: 'Gabon' },
    { value: 'GBR', label: 'Royaume-Uni' },
    { value: 'GEO', label: 'Géorgie' },
    { value: 'GHA', label: 'Ghana' },
    { value: 'GIB', label: 'Gibraltar' },
    { value: 'GIN', label: 'Guinée' },
    { value: 'GMB', label: 'Gambie' },
    { value: 'GNB', label: 'Guinée-Bissau' },
    { value: 'GNQ', label: 'Guinée équatoriale' },
    { value: 'GRC', label: 'Grèce' },
    { value: 'GRD', label: 'Grenade' },
    { value: 'GTM', label: 'Guatemala' },
    { value: 'GUY', label: 'Guyana' },
    { value: 'HND', label: 'Honduras' },
    { value: 'HRV', label: 'Croatie' },
    { value: 'HTI', label: 'Haïti' },
    { value: 'HUN', label: 'Hongrie' },
    { value: 'IDN', label: 'Indonésie' },
    { value: 'IND', label: 'Inde' },
    { value: 'IRL', label: 'Irlande' },
    { value: 'IRN', label: 'Iran' },
    { value: 'IRQ', label: 'Irak' },
    { value: 'ISL', label: 'Islande' },
    { value: 'ISR', label: 'Israël' },
    { value: 'ITA', label: 'Italie' },
    { value: 'JAM', label: 'Jamaïque' },
    { value: 'JOR', label: 'Jordanie' },
    { value: 'JPN', label: 'Japon' },
    { value: 'KAZ', label: 'Kazakhstan' },
    { value: 'KEN', label: 'Kenya' },
    { value: 'KGZ', label: 'Kirghizistan' },
    { value: 'KIR', label: 'Kiribati' },
    { value: 'KOR', label: 'Corée du Sud' },
    { value: 'KWT', label: 'Koweït' },
    { value: 'LAO', label: 'Laos' },
    { value: 'LBN', label: 'Liban' },
    { value: 'LBR', label: 'Libéria' },
    { value: 'LBY', label: 'Libye' },
    { value: 'LIE', label: 'Liechtenstein' },
    { value: 'LKA', label: 'Sri Lanka' },
    { value: 'LSO', label: 'Lesotho' },
    { value: 'LTU', label: 'Lituanie' },
    { value: 'LUX', label: 'Luxembourg' },
    { value: 'LVA', label: 'Lettonie' },
    { value: 'MAR', label: 'Maroc' },
    { value: 'MCO', label: 'Monaco' },
    { value: 'MDG', label: 'Madagascar' },
    { value: 'MDV', label: 'Maldives' },
    { value: 'MEX', label: 'Mexique' },
    { value: 'MKD', label: 'Macédoine' },
    { value: 'MLI', label: 'Mali' },
    { value: 'MLT', label: 'Malte' },
    { value: 'MMR', label: 'Birmanie' },
    { value: 'MNE', label: 'Monténégro' },
    { value: 'MNG', label: 'Mongolie' },
    { value: 'MOZ', label: 'Mozambique' },
    { value: 'MRT', label: 'Mauritanie' },
    { value: 'MUS', label: 'Maurice' },
    { value: 'MWI', label: 'Malawi' },
    { value: 'MYS', label: 'Malaisie' },
    { value: 'NAM', label: 'Namibie' },
    { value: 'NER', label: 'Niger' },
    { value: 'NGA', label: 'Nigéria' },
    { value: 'NIC', label: 'Nicaragua' },
    { value: 'NLD', label: 'Pays-Bas' },
    { value: 'NOR', label: 'Norvège' },
    { value: 'NPL', label: 'Népal' },
    { value: 'NZL', label: 'Nouvelle-Zélande' },
    { value: 'OMN', label: 'Oman' },
    { value: 'PAK', label: 'Pakistan' },
    { value: 'PAN', label: 'Panama' },
    { value: 'PER', label: 'Pérou' },
    { value: 'PHL', label: 'Philippines' },
    { value: 'PNG', label: 'Papouasie-Nouvelle-Guinée' },
    { value: 'POL', label: 'Pologne' },
    { value: 'PRI', label: 'Porto Rico' },
    { value: 'PRK', label: 'Corée du Nord' },
    { value: 'PRT', label: 'Portugal' },
    { value: 'PRY', label: 'Paraguay' },
    { value: 'QAT', label: 'Qatar' },
    { value: 'ROU', label: 'Roumanie' },
    { value: 'RUS', label: 'Russie' },
    { value: 'RWA', label: 'Rwanda' },
    { value: 'SAU', label: 'Arabie Saoudite' },
    { value: 'SDN', label: 'Soudan' },
    { value: 'SEN', label: 'Sénégal' },
    { value: 'SGP', label: 'Singapour' },
    { value: 'SLE', label: 'Sierra Leone' },
    { value: 'SLV', label: 'Salvador' },
    { value: 'SOM', label: 'Somalie' },
    { value: 'SRB', label: 'Serbie' },
    { value: 'SUR', label: 'Suriname' },
    { value: 'SVK', label: 'Slovaquie' },
    { value: 'SVN', label: 'Slovénie' },
    { value: 'SWE', label: 'Suède' },
    { value: 'SWZ', label: 'Swaziland' },
    { value: 'SYR', label: 'Syrie' },
    { value: 'TCD', label: 'Tchad' },
    { value: 'TGO', label: 'Togo' },
    { value: 'THA', label: 'Thaïlande' },
    { value: 'TJK', label: 'Tadjikistan' },
    { value: 'TKM', label: 'Turkménistan' },
    { value: 'TLS', label: 'Timor-Oriental' },
    { value: 'TUN', label: 'Tunisie' },
    { value: 'TUR', label: 'Turquie' },
    { value: 'TUV', label: 'Tuvalu' },
    { value: 'TWN', label: 'Taïwan' },
    { value: 'TZA', label: 'Tanzanie' },
    { value: 'UGA', label: 'Ouganda' },
    { value: 'UKR', label: 'Ukraine' },
    { value: 'URY', label: 'Uruguay' },
    { value: 'USA', label: 'États-Unis' },
    { value: 'UZB', label: 'Ouzbékistan' },
    { value: 'VAT', label: 'Vatican' },
    { value: 'VCT', label: 'St-Vincent-et-les-Grenadines' },
    { value: 'VEN', label: 'Venezuela' },
    { value: 'VNM', label: 'Vietnam' },
    { value: 'YEM', label: 'Yémen' },
    { value: 'ZAF', label: 'Afrique du Sud' },
    { value: 'ZMB', label: 'Zambie' },
    { value: 'ZWE', label: 'Zimbabwe' },
]

/**
	Regroupe Ici les différent référentiel en dur de l'application mobile.
**/

export { DepList, CountryList }
